import { render, staticRenderFns } from "./Subcontent.vue?vue&type=template&id=7b970975&"
import script from "./Subcontent.vue?vue&type=script&lang=js&"
export * from "./Subcontent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports